export class CommunityCoordination{
    id : number;
    code : string;
    name : string;
    displayOrder : number;
  } 